<template>
  <div class="scard-list">
    <article
      class="scard scard--turk"
      :class="{ 'scard--hover': hoverState.heilpraktiker }"
      @click="startRechner('heilpraktiker')"
      @mouseover="hoverState.heilpraktiker = true"
      @mouseleave="hoverState.heilpraktiker = false"
      role="button"
      tabindex="0"
    >
      <div class="scard__top">
        <div class="scard__icon scard__icon--turk">
          <v-icon icon="mdi-meditation" color="#088A85" size="32" />
        </div>
        <div class="scard__body">
          <span class="scard__eyebrow">
            <span class="scard__dot scard__dot--turk"></span>HEILPRAKTIKER
          </span>
          <h3 class="scard__title">Heilpraktiker Zusatzversicherung</h3>
          <p class="scard__sub">
            Schwerpunkt Heilpraktiker &amp; Naturheilverfahren
          </p>
        </div>
      </div>

      <ul class="scard__chips scard__chips--turk">
        <li><v-icon size="11" color="#066460">mdi-check</v-icon>Naturheilkunde</li>
        <li><v-icon size="11" color="#066460">mdi-check</v-icon>Akupunktur</li>
        <li><v-icon size="11" color="#066460">mdi-check</v-icon>Osteopathie</li>
      </ul>

      <div class="scard__foot">
        <v-btn
          variant="flat"
          color="primary"
          rounded="0"
          size="default"
          class="nocaps scard__btn"
          append-icon="mdi-arrow-right-circle"
        >
          Vergleich starten
        </v-btn>
      </div>
    </article>

    <article
      class="scard scard--orange"
      :class="{ 'scard--hover': hoverState.brille }"
      @click="startRechner('brille')"
      @mouseover="hoverState.brille = true"
      @mouseleave="hoverState.brille = false"
      role="button"
      tabindex="0"
    >
      <div class="scard__top">
        <div class="scard__icon scard__icon--orange">
          <v-icon icon="mdi-glasses" color="#FF8000" size="32" />
        </div>
        <div class="scard__body">
          <span class="scard__eyebrow">
            <span class="scard__dot scard__dot--orange"></span>BRILLE
          </span>
          <h3 class="scard__title">Brillen Zusatzversicherung</h3>
          <p class="scard__sub">
            Schwerpunkt Brillen, Sehhilfen &amp; augenärztliche Behandlungen
          </p>
        </div>
      </div>

      <ul class="scard__chips scard__chips--orange">
        <li><v-icon size="11" color="#b25b00">mdi-check</v-icon>Sehhilfen</li>
        <li><v-icon size="11" color="#b25b00">mdi-check</v-icon>Kontaktlinsen</li>
        <li><v-icon size="11" color="#b25b00">mdi-check</v-icon>Lasik</li>
      </ul>

      <div class="scard__foot">
        <v-btn
          variant="flat"
          color="primary"
          rounded="0"
          size="default"
          class="nocaps scard__btn"
          append-icon="mdi-arrow-right-circle"
        >
          Vergleich starten
        </v-btn>
      </div>
    </article>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const hoverState = reactive({
  brille: false,
  heilpraktiker: false,
});

function startRechner(segment) {
  switch (segment) {
    case "brille":
      router.push("/vergleich/starten/brille");
      break;
    case "heilpraktiker":
      router.push("/vergleich/starten/heilpraktiker");
      break;
    default:
      console.error("Unbekanntes Segment:", segment);
  }
}
</script>

<style scoped>
.scard-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.scard {
  position: relative;
  background: #ffffff;
  border: 1px solid #d8dde5;
  border-left: 3px solid #d8dde5;
  border-radius: 3px;
  padding: 14px 16px 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease,
    box-shadow 0.15s ease, transform 0.15s ease;
  display: grid;
  grid-template-rows: auto auto auto;
  gap: 12px;
}
.scard:hover,
.scard--hover {
  background: #fbfcfe;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04),
    0 6px 20px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.scard--turk {
  border-left-color: #088a85;
}
.scard--turk:hover,
.scard--turk.scard--hover {
  background: #f3f9f8;
  border-color: #b8dad8;
  border-left-color: #088a85;
}
.scard--orange {
  border-left-color: #ff8000;
}
.scard--orange:hover,
.scard--orange.scard--hover {
  background: #fff5e6;
  border-color: #f5d3a0;
  border-left-color: #ff8000;
}

.scard__top {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  gap: 14px;
  align-items: center;
}
.scard__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: #fafbfc;
  border: 1px solid #eef1f6;
  border-radius: 3px;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.scard:hover .scard__icon--turk,
.scard--hover .scard__icon--turk {
  background: #e3f1ef;
  border-color: #b8dad8;
}
.scard:hover .scard__icon--orange,
.scard--hover .scard__icon--orange {
  background: #ffe9cc;
  border-color: #f5d3a0;
}

.scard__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.scard__eyebrow {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #5b6473;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
.scard__dot {
  width: 6px;
  height: 6px;
  display: inline-block;
  margin-right: 8px;
}
.scard__dot--turk {
  background: #088a85;
}
.scard__dot--orange {
  background: #ff8000;
}
.scard__title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
}
.scard__sub {
  font-size: 12.5px;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
}

.scard__chips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.scard__chips li {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.2px;
  border-radius: 999px;
  padding: 3px 10px 3px 8px;
}
.scard__chips--turk li {
  color: #066460;
  background: #e3f1ef;
  border: 1px solid #b8dad8;
}
.scard__chips--orange li {
  color: #b25b00;
  background: #fff0d6;
  border: 1px solid #f5d3a0;
}

.scard__foot {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px dashed #eef1f6;
  padding-top: 10px;
}
.scard__btn {
  letter-spacing: 0.2px;
  font-weight: 700;
}

@media (max-width: 780px) {
  .scard {
    padding: 12px 12px 10px;
    gap: 10px;
  }
  .scard__top {
    grid-template-columns: 48px minmax(0, 1fr);
    gap: 10px;
  }
  .scard__icon {
    width: 48px;
    height: 48px;
  }
  .scard__title {
    font-size: 15px;
  }
  .scard__sub {
    font-size: 12px;
  }
  .scard__chips li {
    font-size: 11px;
    padding: 2px 8px 2px 6px;
  }
  .scard__foot {
    justify-content: stretch;
  }
  .scard__btn {
    flex: 1 1 auto;
    width: 100%;
  }
}
</style>
